import { render, staticRenderFns } from "./MetinPage.vue?vue&type=template&id=79fe34fa&scoped=true&"
import script from "./MetinPage.vue?vue&type=script&lang=js&"
export * from "./MetinPage.vue?vue&type=script&lang=js&"
import style0 from "./MetinPage.vue?vue&type=style&index=0&id=79fe34fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fe34fa",
  null
  
)

export default component.exports